import requestFunctions from "../../functions/requestFunctions";


export const state = {
  ACCOUNTS_ITEM: {},
  ACCOUNTS_LIST: [],
  ACCOUNTS_TABLE_DATA: [],
  ACCOUNTS_ARRAY_DATA: [],
  ACCOUNTS_TOTAL_ROWS: 0
}

export const getters = {
  GET_ACCOUNTS_ITEM: (state) => {
    return state.ACCOUNTS_ITEM;
  },
  GET_ACCOUNTS_LIST: (state) => {
    return state.ACCOUNTS_LIST;
  },
  GET_ACCOUNTS_TABLE_DATA: (state) => {
    return state.ACCOUNTS_TABLE_DATA;
  },
  GET_ACCOUNTS_ARRAY_DATA: (state) => {
    return state.ACCOUNTS_ARRAY_DATA;
  },
  GET_ACCOUNTS_TOTAL_ROWS: (state) => {
    return state.ACCOUNTS_TOTAL_ROWS;
  }
}

export const mutations = {
  UPDATE_ACCOUNTS_ITEM(state, item) {
    state.ACCOUNTS_ITEM = item;
  },
  UPDATE_ACCOUNTS_LIST(state, list) {

    state.ACCOUNTS_LIST = list.data;
    state.ACCOUNTS_TABLE_DATA = [];
    state.ACCOUNTS_ARRAY_DATA = [];

    state.ACCOUNTS_TOTAL_ROWS = list.total;
    list = list.data;

    list.forEach(el => {

      let fullname = '';

      if (el.profile_name3) { fullname = fullname + el.profile_name3 + ' '; }
      if (el.profile_name1) { fullname = fullname + el.profile_name1 + ' '; }
      if (el.profile_name2) { fullname = fullname + el.profile_name2 + ' '; }

      let status;
      if(el.status === 'active'){
        status = 'Активный'
      }
      if(el.status === 'wait'){
        status = 'Ожидает активации'
      }
      if(el.status === 'blocked'){
        status = 'Заблокирован'
      }
      if(el.status === 'disabled'){
        status = 'Отключен'
      }

      let phone    = el.user_phone ? el.user_phone : '';
      let user_info = phone;
      if (fullname !== ''){
        if(user_info !== ''){
          user_info = user_info +  ', ';
        }
        user_info = user_info + fullname;
      }

      state.ACCOUNTS_TABLE_DATA.push({
        'number'        : el.number,
        'user_info'     : user_info,
        'balance_bonus' : el.balance_bonus,
        'balance_rub'   : el.balance_rub,
        'balance_usd'   : el.balance_usd,
        'balance_eur'   : el.balance_eur,
        'balance_dates' : el.balance_dates,
        'status'        : status,
        'activated_at'  : el.activated_at,
        'uuid'          : el.uuid
      });

      state.ACCOUNTS_ARRAY_DATA.push({
        'id': el.id,
        'name': el.number + ' ' + user_info,
        'user_info': user_info, 
        'user_id': el.user_id,
      });
    });
  },
}

export const actions = {

  async FETCH_ACCOUNTS_ITEM({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/accounts/'+payload.uuid;
    
    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_ACCOUNTS_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_ACCOUNTS_LIST({ commit }, payload = {}) {

    let query_url = 'https://api.tradeanalytic.ru/v1/accounts';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_ACCOUNTS_LIST', response.data);
      return response.data;
    }

  },

  async FETCH_ACCOUNTS_CREATE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/accounts';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_ACCOUNTS_UPDATE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/accounts/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_ACCOUNTS_DELETE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/accounts/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

}